import ic_exit from '@/assets/icons/core/ic_core_exit.svg?raw';
import { selectAll } from "d3";
import { Litepicker } from 'litepicker';
import 'litepicker/dist/plugins/mobilefriendly';
import { DateTime } from 'litepicker/dist/types/datetime';
import { ILPConfiguration } from 'litepicker/dist/types/interfaces';
import { _IS_SAFARI_NAVIGATOR, _IsMobileDevice } from "../../utils/Device";
import { IInputConfig, Input } from "./Input";
import '/styles/components/InputDate.scss';

type IInputConfigPick = Pick<IInputConfig, "disabled" | "id" | "max" | "min" | "required" | /* "value" | */ "placeholder">
type InputDateFormat = InputDateFormat_Date // | InputDateFormat_Time | { [d in InputDateFormat_Date]: { [t in InputDateFormat_Time]: `${d} ${t}` }[InputDateFormat_Time] }[InputDateFormat_Date]
type InputDateFormat_Date = "D MMM YYYY" | "D MMMM YYYY" | "YYYY-MM-DD" | "DD/MM/YYYY" | "DD/MM/YY"
type TValue = number | string | Date

export interface IInputDateConfig extends IInputConfigPick {
    value?: TValue
    pickerOptions?: Pick<ILPConfiguration, "numberOfMonths" | "numberOfColumns" | "maxDate"> & {
        footer?: HTMLElement
    }
    format: InputDateFormat
    lockDays?: any[]
    highlightedDays?: any[]
    onSelectDt?: (date: DateTime | null) => void
}

export class InputDate extends Input {
    private cf: IInputDateConfig
    private picker: Litepicker

    constructor(container: TSelection | HTMLElement, config: IInputDateConfig) {
        super(container, (() => {
            const cf = <IInputConfigPick>{ ...config }
            delete cf["value"]
            return cf
        })())
        this.cf = config

        this.Init()
    }

    private Init() {
        const cf = this.cf
        const pickerOptions = cf.pickerOptions

        this.divWrapper.classed("input-date-wrapper", true)

        this.picker = new Litepicker({
            ...(pickerOptions),
            autoRefresh: true,
            element: this.input.node(),
            dropdowns: {
                minYear: 1990,
                maxYear: null,
                months: true,
                years: true,
            },
            numberOfMonths: _IsMobileDevice() ? 1 : pickerOptions.numberOfMonths, // FIXME config para MobileDevice no funciona, muestra dos meses :c
            numberOfColumns: _IsMobileDevice() ? 1 : pickerOptions.numberOfColumns, // FIXME config para MobileDevice no funciona, muestra dos meses :c
            mobileFriendly: true,
            lockDays: cf.lockDays || [],
            highlightedDays: cf.highlightedDays || [],
            highlightedDaysFormat: "background-color:rgb(232, 250, 255);",
            maxDate: cf.max,
            minDate: cf.min,
            plugins: ['mobilefriendly'],
            format: cf.format || undefined,
            setup: (picker) => {
                picker.on('selected', (dt1, _dt2) => {
                    this.Validate()
                    if (cf.onSelectDt) cf.onSelectDt(dt1)
                })
                picker.on('hide', () => this.Validate())

                picker.on("render", (container: HTMLElement) => {
                    const btnClose = document.createElement("div")
                    btnClose.className = "btn-close"
                    btnClose.innerHTML = ic_exit
                    btnClose.onclick = () => picker.hide()
                    container.append(btnClose);
                })

                // draw footer
                if (pickerOptions.footer)
                    picker.on('render:footer', (footerContainer: HTMLElement) => {
                        footerContainer.append(pickerOptions.footer)
                    })
            },
            footerHTML: pickerOptions.footer
                ? `<span class="preview-date-range hide"></div>`
                : undefined,

        })

        if (cf?.value) {
            if (typeof cf.value == "string" && this.esFormatoFechaCorto(cf.value))
                this.picker.setDate(cf.value.split("-").reverse().join("/"))
            else
                this.picker.setDate(cf.value)
        }

        if (_IS_SAFARI_NAVIGATOR && _IsMobileDevice()) {
            this.divWrapper.node().onclick = () => setTimeout(() => {
                this.picker.show()
            });
            selectAll(".litepicker").classed("litepicker-mobile", true)
                .style("position", "absolute")
                .style("right", "0")
                .style("button", "0")
        }
    }

    private esFormatoFechaCorto(fecha: string): boolean {
        return /^\d{4}-\d{2}-\d{2}$/.test(fecha);
    }

    /**
     * Use 'date.toISOString()'
     * @example "2024-10-11T06:00:00.000Z"
     */
    public ISOValueWithoutZH(): string {
        const val = this.picker.getDate()
        if (!val) return null
        const dt = val.toJSDate()
        return dt.toISOString()
    }

    public get Picker(): Litepicker {
        return this.picker
    }
}